import clsx from "clsx";
import type { CSSProperties } from "react";
import { Link } from "react-router";
import { Icon } from "../Icon";
import type { IconName } from "../Icon.icons";

type NavButtonProps = {
  icon: IconName;
  label: string;
  href: string;
  selected?: boolean;
  style?: CSSProperties;
  className?: string;
};

export function NavButton({ icon, label, href, selected = false, style, className }: NavButtonProps) {
  return (
    <Link
      to={href}
      aria-label={label}
      style={style}
      data-selected={selected || undefined}
      className={clsx(
        "flex items-center justify-center no-underline cursor-pointer",
        "text-foreground rounded-medium h-[48px] p-component-medium",
        "hover:bg-accent",
        "focus-visible:bg-accent",
        "focus-visible:outline focus-visible:outline-1 focus-visible:outline-accent-foreground",
        "focus-visible:text-accent-foreground",
        "data-[selected]:bg-accent",
        "data-[selected]:text-primary",
        className,
      )}
    >
      <Icon name={icon} variant="filled" size={24} />
    </Link>
  );
}
